import React, { useState } from "react";
import { Layout } from "antd";

import SearchBar from "../../../containers/HomePage/SearchBar";
import SideMenu from "../../../containers/SideMenu";
import HeaderLogo from "../../HeaderLogo";
import styles from "./mobileHeader.scss";
import MenuIcon from "./MenuIcon";
import { HEADER_ID } from "../../../constants";
import { MessagesLink } from "../MessagesLink/MessagesLink";

const MobileHeader = (props: any) => {
  const {
    isHomePage,
    onSubmitAdClick,
    showLogoAndSearchBar,
    onLogoClick,
    scrolling,
    user,
  } = props;
  const [showSideMenu, setshowSideMenu] = useState(false);

  const handleMenuClick = () => {
    document.documentElement.style.setProperty('--scroll-position', `-${window.scrollY}px`);
    document.body.classList.add('menu-open');

    setshowSideMenu(true);
  };

  const handleMenuClose = () => {
    const scrollY = document.documentElement.style.getPropertyValue('--scroll-position');
    document.body.classList.remove('menu-open');
    window.scrollTo(0, parseInt(scrollY || '0') * -1);

    setshowSideMenu(false);
  };

  return (
    <Layout.Header className={styles.headerMobileContainer} id={HEADER_ID}>
      <div
        style={isHomePage && !scrolling ? { backgroundColor: "transparent" } : null}
        className={scrolling ? styles.headerScrolling : styles.header}
      >
        <div className={styles.leftMenu}>
          <MenuIcon onClick={handleMenuClick} />
          <SideMenu
            visible={showSideMenu}
            onSubmitAdClick={onSubmitAdClick}
            onMenuClose={handleMenuClose}
          />
          {showLogoAndSearchBar && (
            <HeaderLogo className={styles.logo} onClick={onLogoClick} />
          )}
        </div>
        {!showLogoAndSearchBar && (
          <HeaderLogo className={styles.logo} onClick={onLogoClick} />
        )}

        {user && (
          <MessagesLink />
        )}

        <div className={styles.rightMenu}>

          {/* show search icon on home page only after first scroll */}
          <SearchBar isMobile iconOnly isHomePage={isHomePage} />
        </div>
      </div>
    </Layout.Header>
  );
}

export default MobileHeader;



// WEBPACK FOOTER //
// ./src/components/Header/MobileHeader/index.tsx